module.exports = __webpack_public_path__ + "img/ready.4ba44ac9.png";